<template>
    <div>
        <div class="search-header">
            <div class="search-bar">
              <input class="search" confirm-type="search" placeholder="搜索常见技术问题" />
              <img src="../assets/images/public/i35.png" />
            </div>
          </div>
    </div>
  </template>
    
  <script>
  export default {
    data() {
      return {
        
      }
    },
    methods: {
      
    }
  }
  </script>
  <style lang="scss" scoped>
  .search-header {
  width: 1200px;
  margin: 40px auto;
}

.search-header .search-bar {
  width: 25%;
  height: 35px;
  border-radius: 25px;
  background-color: white;
  display: flex;
  float: right;
  align-items: center;
  border: 1px solid #B2B2B2;
}

.search-header .search-bar .search {
  width: 95%;
  margin-left: 10px;
  border: 0;
}

.search-bar img {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
  </style>
    


// WEBPACK FOOTER //
// src/components/search.vue